import { UserDTO } from 'types/User';
import { CDT_BACKEND_URL } from 'services/constants';
import { axiosInstance } from 'shared/axios/axiosConfig';

/**
 * Call the pcm-prospect-frontend-controller to get the user details of the logged in user
 */
const getUser = async (): Promise<UserDTO> => {
  const json = await axiosInstance.get(`/getUserDetails`);
  return json.data;
};

/**
 * Call the cdt backend service to get the user's business entity country code of the logged in user
 */
const getUserBusinessEntity = async () => {
  const response = await axiosInstance.get(`${CDT_BACKEND_URL}/api/user/business-entity`);
  return response.data;
};

const userService = { getUser, getUserBusinessEntity };
export default userService;
